import React from 'react';
import { Field } from '../../pages/AdminStoreDetail/Menu/ProductItem/ProductOrderSheet/ProductEditModal/styled';
import { HeaderSmall } from '../Text';
import Button from '../Button';
import Color from '@/utils/color';
import i18n from '@/utils/i18n';
import { ButtonContainer, Spacer } from './styled';

type CustomOnChangeEventType = {
  target: {
    value: number;
    type: string;
    name: string;
  };
};

type VatSelectorProps = {
  vatRates: number[];
  vatRate: number;
  onChange: (event: CustomOnChangeEventType) => {};
};

export default function VatSelector({
  vatRates,
  vatRate,
  onChange,
}: VatSelectorProps) {
  function onClick(newVatRate: number) {
    onChange({
      target: {
        value: newVatRate,
        type: 'number',
        name: 'vat_rate',
      },
    });
  }

  if (vatRate === undefined) {
    vatRate = vatRates[0];
    // onClick(vatRates[0])
  }

  return (
    <Field>
      <HeaderSmall>{i18n.t('Menu:vatRate')}</HeaderSmall>
      <ButtonContainer>
        {vatRates.map((v) => {
          return (
            <div>
              <Button
                color={v === vatRate ? Color.Cyan : undefined}
                small
                onClick={() => onClick(v)}
              >
                {v / 10}%
              </Button>
              <Spacer />
            </div>
          );
        })}
      </ButtonContainer>
    </Field>
  );
}
